module.exports = __webpack_public_path__ + "static/img/rank-top.f07cf41.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/rank-top.png
// module id = VPCB
// module chunks = 1